import React, { FunctionComponent } from 'react';
import dataAtIds from '../../dataAtIds.json';
import useFilters, { TypeFilterLabel } from './useFilters';
import { trackEvent } from '../../utils/tracking';
import FiltersGroup from './FiltersGroup';
import FiltersGroupLabel from './FiltersGroupLabel';
import FiltersLabel from './FiltersLabel';
import './Filters.css';

interface Props {
  onChange?: () => void;
}

const Filters: FunctionComponent<Props> = (props) => {
  const { onChange, ...rest } = props;
  const { clearFilters, deselectFilter, filtersGrouped } = useFilters();

  const handleDeselectFilter = (filter: TypeFilterLabel) => {
    trackEvent('Filters.Removed', {
      attribute: filter.type,
      value: filter.value,
    });

    deselectFilter(filter);

    if (typeof onChange === 'function') {
      onChange();
    }
  };

  const handleClearFilters = () => {
    trackEvent('Filters.Cleared', {});

    clearFilters();

    if (typeof onChange === 'function') {
      onChange();
    }
  };

  return (
    <div {...rest} className="Filters">
      {filtersGrouped.map(([attribute, filters]) => (
        <FiltersGroup key={attribute}>
          <FiltersGroupLabel attribute={attribute} />

          {filters.map((filter) => (
            <FiltersLabel
              data-trace-at-id={dataAtIds.AttributeFiltersLabel}
              gap="x1"
              icon="MinusRemove"
              key={`${filter.type}-${filter.value}`}
              level="primary"
              onClick={() => handleDeselectFilter(filter)}
            >
              {filter.value}
            </FiltersLabel>
          ))}
        </FiltersGroup>
      ))}

      {filtersGrouped.length > 0 && (
        <FiltersGroup>
          <FiltersLabel
            data-trace-at-id={dataAtIds.AttributeFiltersClear}
            icon="CloseSmall"
            level="secondary"
            onClick={handleClearFilters}
          >
            Clear
          </FiltersLabel>
        </FiltersGroup>
      )}
    </div>
  );
};

export default Filters;
